import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Form } from '@ant-design/compatible';
import SendMessageServiceModal from '../../../../views/app/common/modal/SendMessageServiceModal';
import withModal from '../../../../lib/hoc/withModal';
import { appActions } from '../../../../store/modules/app';
import { asyncSimpleModal } from '../../../../lib/common';
import {
  MSG_SERVICE_SEND_MODAL_SECTION_TYPE,
  MSG_SERVICE_SEND_TYPE,
} from '../../../../constants/service/app/msgServiceSendConstants';
import { AMONDZ_MEMBER_TYPE_TEXT } from '../../../../constants/service/common/utilConstants';

class SendMessageServiceModalContainer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      /**
       *  섹션 타입
       */
      sectionType: MSG_SERVICE_SEND_MODAL_SECTION_TYPE.SELECT_MSG_SERVICE_TYPE_SECTION,
      /**
       *  메시지 타입
       */
      msgType: MSG_SERVICE_SEND_TYPE.SMS,
      /**
       *  제목
       */
      subject: null,
      /**
       *  본문
       */
      content: null,
    };
  }

  /**
   * 문자 메시지 발송하기
   */
  onSubmit = () => {
    const { form, sendMessageService, data } = this.props;
    const { memberType, receiverInfo } = data;
    const { msgType, subject, content } = this.state;

    form.validateFieldsAndScroll((err) => {
      if (err) return;

      sendMessageService({
        msgType,
        subject,
        content,
        receiverName: receiverInfo.targetId
          ? `${receiverInfo.name ? receiverInfo.name : receiverInfo.subInfo}(${receiverInfo.targetId})/(${
              AMONDZ_MEMBER_TYPE_TEXT[memberType]
            })`
          : '-',
        cellPhone: receiverInfo.cellPhone,
      });
    });
  };

  /**
   * 데이터 변경
   */
  setData = (data) => {
    this.setState({
      [data.name]: data.value,
    });
  };

  /**
   * 모달 닫기 || 데이터 초기화
   */
  closeModal = () => {
    this.props.toggleModal({
      name: 'sendMessageServiceModal',
      data: {},
      value: false,
    });
  };

  /**
   * 뒤로가기
   */
  goBack = async () => {
    const confirmResult = await asyncSimpleModal({
      type: 'confirm',
      title: '경고',
      message: '뒤로 이동하시면 입력하신 데이터가 초기화됩니다.\n 그래도 진행을 하시겠습니까?',
    });

    if (!confirmResult) return;

    this.setState({
      sectionType: MSG_SERVICE_SEND_MODAL_SECTION_TYPE.SELECT_MSG_SERVICE_TYPE_SECTION,
      subject: null,
      content: null,
    });
  };

  render() {
    return (
      <SendMessageServiceModal
        {...this.state}
        {...this.props}
        onSubmit={this.onSubmit}
        setData={this.setData}
        goBack={this.goBack}
        closeModal={this.closeModal}
      />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    isOpen: state.app.sendMessageServiceModal.isOpen,
    data: state.app.sendMessageServiceModal.data,
  };
};

const mapDispatchToProps = {
  toggleModal: appActions.appToggleModal,
  sendMessageService: appActions.sendMessageService,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withModal()(Form.create({})(SendMessageServiceModalContainer)));
